import { UserListComponent } from './users-list.component';

export default angular
  .module('sfMobile.components.users-list', [])
  .component('sfUsersList', UserListComponent).name;
